import { GAME_HEIGHT, GAME_WIDTH } from './game';

const MAX_RENDER_SCALE = 1.5;
const MOBILE_FPS_LIMIT = 40;

function resolveRenderScale() {
  if (typeof window === 'undefined') {
    return 1;
  }

  const dpr = window.devicePixelRatio || 1;
  return Math.max(1, Math.min(MAX_RENDER_SCALE, dpr));
}

function isMobileLike() {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.innerWidth < 700 || navigator.maxTouchPoints > 1;
}

export const RENDER_SCALE = resolveRenderScale();
export const RENDER_WIDTH = Math.round(GAME_WIDTH * RENDER_SCALE);
export const RENDER_HEIGHT = Math.round(GAME_HEIGHT * RENDER_SCALE);
export const FPS_LIMIT = isMobileLike() ? MOBILE_FPS_LIMIT : 0;
